/* eslint-disable react/no-unknown-property */
import React from 'react';
import {
  FontWeight,
  Form, FormHandlers, FormProps, Text,
} from '@doveit/bricks';
import { SurveyAnswer } from '../../../providers/api/dtos';
import * as styles from './FeedbackForm.style';

export interface FeedbackFormModel {
  answers: {
    [key: SurveyAnswer['questionId']]: string,
  },
  notes: string,
}

export interface FeedbackFormProps {
  answers: SurveyAnswer[],
  notes?: string,
  innerRef?: React.MutableRefObject<FormHandlers>,
  loading?: FormProps<FeedbackFormModel>['loading'],
  disabled?: FormProps<FeedbackFormModel>['disabled'],
  onSubmit: FormProps<FeedbackFormModel>['onSubmit'],
}

const FeedbackForm: React.FC<FeedbackFormProps> = ({
  answers = [],
  notes,
  innerRef,
  ...rest
}) => {
  const initialValues = React.useMemo(() => ({
    answers: answers.reduce((acc, current: SurveyAnswer) => {
      acc[current.questionId] = (typeof current.value === 'number' ? `${current.value}` : (current.value || '')) as string;

      return acc;
    }, {} as FeedbackFormModel['answers']),
    notes: notes || '',
  }), [answers, notes]);

  return (
    <Form
      initialValues={initialValues}
      innerRef={innerRef}
      {...rest}
    >
      {answers.map((answer, index) => {
        const name = `answers.${answer.questionId}`;

        return (
          <Form.Item key={answer.questionId}>
            <div css={styles.questionHeader}>
              <Text.Body
                color="primary.default.low"
                fontWeight={FontWeight.MEDIUM}
                as="div"
              >
                {index + 1}. {answer.question}
              </Text.Body>
              {answer.description && (
                <Text.BodySmall>
                  {answer.description}
                </Text.BodySmall>
              )}
            </div>
            {answer.type === 'RATING' && (
              <Form.Rating aria-label="Campo per la valutazione" name={name} />
            )}
            {answer.type === 'LONG_TEXT' && (
              <Form.TextArea name={name} />
            )}
          </Form.Item>
        );
      })}
      <Form.Item>
        <Form.TextArea
          label="Note"
          name="notes"
        />
      </Form.Item>
    </Form>
  );
};

export default FeedbackForm;
